<template>
    <div class="mt-8">
        <div class="mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
                <component :is="widget.name" v-for="widget in widgets" :widget="widget" :key="widget.uuid" />
            </div>
        </div>
    </div>
</template>
<script>
import BookmarksWidget from '@/components/Widgets/Teacher/BookmarksWidget.vue';
import BirthdaysWidget from '@/components/Widgets/Teacher/BirthdaysWidget.vue';
import GraphWidget from '@/components/Widgets/Teacher/GraphWidget.vue';
import GroupFoulsWidget from '@/components/Widgets/Teacher/GroupFoulsWidget.vue';
import UsageSparklineGraphWidget from '@/components/Widgets/Teacher/UsageSparklineGraphWidget.vue';

export default {
    name: 'UsageStatsWidgets',
    components: {
        'sparkline-graph': UsageSparklineGraphWidget,
        'group-fouls': GroupFoulsWidget,
        'teacher-bookmarks': BookmarksWidget,
        'teacher-birthdays': BirthdaysWidget,
        'simple-graph': GraphWidget,
    },
    props: ['widgets'],
};
</script>
